var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44441_163679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 12H13.8333C14.2 12 14.5 11.7 14.5 11.3333C14.5 10.9667 14.2 10.6667 13.8333 10.6667H3.16667C2.8 10.6667 2.5 10.9667 2.5 11.3333C2.5 11.7 2.8 12 3.16667 12ZM3.16667 8.66667H13.8333C14.2 8.66667 14.5 8.36667 14.5 8C14.5 7.63333 14.2 7.33333 13.8333 7.33333H3.16667C2.8 7.33333 2.5 7.63333 2.5 8C2.5 8.36667 2.8 8.66667 3.16667 8.66667ZM2.5 4.66667C2.5 5.03333 2.8 5.33333 3.16667 5.33333H13.8333C14.2 5.33333 14.5 5.03333 14.5 4.66667C14.5 4.3 14.2 4 13.8333 4H3.16667C2.8 4 2.5 4.3 2.5 4.66667Z",
    fill: "#003DA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44441_163679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.469f6078e3857ad092062336000d1676.svg";
export { ForwardRef as ReactComponent };